

















































































import Vue from 'vue'

export default Vue.extend({
  name: 'Login',
  data: (): any => ({
    errorMessages: '',
    email: '',
    password: '',
    passwordShow: false,
    formHasErrors: false,
    rules: {
      required: (v: string) => !!v || '해당 칸을 입력해주세요.',
      email: (v: string) => /.+@.+/.test(v) || '이메일 형식에 맞게 작성해주세요.',
      password: (v: string) => /^.*(?=^.{8,15}$)(?=.*\d)(?=.*[a-zA-Z])(?=.*[!@#$%^&*+=]).*$/.test(v) || '비밀번호는 문자/숫자/특수문자를 포함한 8~15자리로 입력해주세요.',
    }
  }),
  props: {
    message: String
  },
  computed: {
    form (): Record<string, any> {
      return {
        email: this.email,
        password: this.password,
      }
    },
  },

  watch: {
    name (): void {
      this.errorMessages = ''
    },
  },

  methods: {
    resetForm (): void {
      this.errorMessages = ''
      this.formHasErrors = false

      Object.keys(this.form).forEach(f => {
        this.$refs[f].reset()
      })
    },
    submit (): void {
      // validation
      this.formHasErrors = false
      Object.keys(this.form).forEach(f => {
        if (!this.form[f]) this.formHasErrors = true
        if (!this.$refs[f].validate(true)) this.formHasErrors = true
      })
      if (!this.formHasErrors) {
        // axios login
        this.$store.dispatch('userModule/login', this.form)
          // login fail
          .catch((error: any) => {
            alert(error);
          })
        this.errorMessages = '';
        this.email = '';
        this.password = '';
      }
    },
    goToSignup (): void {
      this.$emit('goToSignup')
    },
    close (): void {
      this.$emit('close')
    }
  },
})
